import React from "react"
import * as RouterService from "../services/RouterService"
import RouterPage from "../services/RouterPage";


export async function getServerSideProps(context) {
    return RouterService.getServerSideProps(context)
}

export default function Router(props){
   return(
       <RouterPage {...props}/>
   )
}
